export default "__VITE_ASSET__UmIpHZaI__"